/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Aicost_LeadInputs */

const en_mk_aicost_lead = /** @type {(inputs: Mk_Aicost_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The figures below come from this product’s real usage log, not a simulation. Every run records its tokens and its cost in rupiah, and you can set a spending cap per agent so the end of the month holds no surprises.`)
};

const id_mk_aicost_lead = /** @type {(inputs: Mk_Aicost_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angka di bawah diambil dari log pemakaian nyata produk ini, bukan simulasi. Setiap run mencatat token dan biayanya dalam rupiah, dan Anda bisa memasang batas belanja per agen supaya tidak ada kejutan di akhir bulan.`)
};

/**
* | output |
* | --- |
* | "The figures below come from this product’s real usage log, not a simulation. Every run records its tokens and its cost in rupiah, and you can set a spending ..." |
*
* @param {Mk_Aicost_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_aicost_lead = /** @type {((inputs?: Mk_Aicost_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Aicost_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_aicost_lead(inputs)
	return en_mk_aicost_lead(inputs)
});